// Add your custom JS here.

( function ( $ ) {
    $( '.btn--search a' ).click( function () {
        $( '.bnyn-search-modal' ).toggleClass( 'is-open' );
    } );

    $( '.js-btn-close-search' ).click( function () {
        $( '.bnyn-search-modal' ).removeClass( 'is-open' );
    });

    // Enable the Sticky CTA on the Program page template.
    if (document.body.classList.contains('page-template-program')) {
        const header = document.querySelector('header.bnyn-header-program-desktop');
        const stickyCTA = document.querySelector('#sticky-cta');
        const contactForm = document.querySelector('#form'); // adjust selector

        let headerOutOfView = false;
        let formInView = false;

        const updateCTA = () => {
          if (headerOutOfView && !formInView) {
            stickyCTA.classList.add('visible');
          } else {
            stickyCTA.classList.remove('visible');
          }
        };

        // Observe header
        const headerObserver = new IntersectionObserver( ( [ entry ] ) => {
            headerOutOfView = !entry.isIntersecting;
            updateCTA();
          },
          { threshold: 0 }
        );

        // Observe contact form
        const formObserver = new IntersectionObserver( ( [ entry ] ) => {
            formInView = entry.isIntersecting;
            updateCTA();
          },
          { threshold: 0.1 } // triggers when ~10% is visible
        );

        if (header) headerObserver.observe(header);
        if (contactForm) formObserver.observe(contactForm);
    }
} )( jQuery );


const bnynMobileMenuBreakpoint = 1200;

function setBnynSubmenuState(menuItem, isOpen) {
  const toggle = Array.prototype.find.call(menuItem.children, function(child) {
    return child.matches('a');
  });

  menuItem.classList.toggle('submenu-open', isOpen);

  if (toggle) {
    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  }
}

document
  .querySelectorAll('#header__primary .menu-item-has-children > a')
  .forEach(function(item) {
    item.setAttribute('aria-haspopup', 'true');
    item.setAttribute('aria-expanded', 'false');

    item.addEventListener('click', function(e) {
      if (window.innerWidth <= bnynMobileMenuBreakpoint) {
        e.preventDefault();
        e.stopPropagation();

        const parent = item.parentElement;
        const isOpen = !parent.classList.contains('submenu-open');

        setBnynSubmenuState(parent, isOpen);

        if (!isOpen) {
          parent.querySelectorAll('.submenu-open').forEach(function(openChild) {
            setBnynSubmenuState(openChild, false);
          });
        }
      }
    });
  });
